import { useParams } from "react-router-dom";

import { AcuityScoreBadge } from "@/features/acuity/components/AcuityScoreBadge";
import { Divider2 } from "@/ui2/atoms/Divider";
import type { PatientDetails, UUID } from "@/core/types";

import { PatientData } from "../components/PatientData";

import { getFormattedAcuityDate } from "./helpers/getFormattedAcuityDate";
import { ReportAcuityLegacy } from "./components/ReportMenuLegacy";

type Props = {
  patientDetails: PatientDetails;
};

export function PatientAcuityLegacy({ patientDetails }: Props) {
  const { patientId } = useParams<{ patientId: UUID }>();

  const { acuity_score, acuity_timestamp } = patientDetails || {};

  if (!acuity_score) return null;

  const formattedAcuityDate = acuity_timestamp
    ? getFormattedAcuityDate(acuity_timestamp)
    : undefined;

  return (
    <>
      <div className="tw:flex tw:items-center tw:justify-between tw:gap-1">
        <dl className="tw:flex tw:flex-col tw:gap-2">
          <PatientData
            className="tw:flex tw:items-center"
            classNameChildren="tw:flex"
            label="Acuity Index"
          >
            <AcuityScoreBadge acuityScore={acuity_score} />
          </PatientData>

          {formattedAcuityDate && (
            <PatientData
              className="tw:text-sm tw:text-text-tertiary tw:*:font-normal"
              label="Updated"
            >
              {formattedAcuityDate}
            </PatientData>
          )}
        </dl>

        <ReportAcuityLegacy patientId={patientId} />
      </div>

      <Divider2 className="tw:lg:-ml-4" />
    </>
  );
}
